module.exports = __webpack_public_path__ + "img/hamburger.4b218996.svg";